// extracted by mini-css-extract-plugin
module.exports = {"inputSmall":"date-module--inputSmall--2lrNS","inputLarge":"date-module--inputLarge--JMdkW"};